export enum SignupUrlParameters {
  ORGANISATION_DATA = 'organisation_data',
}
